(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxAnalytics(
    DataExtractService, toastr, $filter, $http, $timeout, EventServiceEvents
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/analytics/analytics.template.html',
      link: function(scope) {

        scope.currentDate = new Date();
        scope.thresholdToSwitchCreatedTimeFormat = 6;
        scope.saving = false;

        (function() {
          listeners();
          getTenantsDataExtractConfig();
          getSoftwareLinks();

        })();

        function getTenantsDataExtractConfig () {
          if (scope.me.permissions.TENANT_ADMIN) {
            DataExtractService.jobDefinitions().then(function () {
              mapRetentionPeriodToBoolean(DataExtractService.jobDefinition.EXTERNAL);
              scope.jobDefinition = {
                PRINTIX: angular.copy(DataExtractService.jobDefinition.PRINTIX),
                EXTERNAL: angular.copy(DataExtractService.jobDefinition.EXTERNAL)
              }

              formListener();
            }).catch(function(error) {});
          }
        }

        function getExtracts (PRINTIX) {

          $http.get(PRINTIX._links['px:dataextracts'].href).then(function(response) {
          }).catch(function(error) {});
        }

        function mapRetentionPeriodToBoolean (EXTERNAL) {
          scope.retentionPeriod = {
            keepData: false
          }
          if (EXTERNAL.retentionPeriod !== '..') {
            scope.retentionPeriod.keepData = false;
          } else {
            scope.retentionPeriod.keepData = true;
          }
        }

        function getSoftwareLinks() {
          $http.get(scope.tenant.info._links["px:software"].href).then(function (response) {
            scope.softwareResources = response.data._embedded['px:softwareResources'];
            setPowerBi();
          }).catch(function(error) {});
        }

        function setPowerBi() {
          scope.powerbi = scope.softwareResources.find((item) => {
            return item.os === 'POWERBI';
          });

          let fileName = scope.powerbi?.files[0]?.path;
          let fileExtension = getFileExtension(fileName);
          scope.powerbiFileType = fileExtension ? '(' + fileExtension.toUpperCase() + ')' : '';
        }

        function getFileExtension(fileName) {
          if (fileName) {
            let lastDotIndex = fileName.lastIndexOf('.');
            if (lastDotIndex !== -1) {
              let fileExtension = fileName.substring(lastDotIndex + 1);
              if (fileExtension) {
                return fileExtension;
              }
            }
          }

          return undefined;
        }

        scope.inclueNameInReport = function (jobDefinition) {
          var url = jobDefinition._embedded.JOBSTypeConfig._links.self.href;

          var patch = [{
            op: 'replace',
            path: '/fields/name/enabled',
            value: jobDefinition._embedded.JOBSTypeConfig.fields.name.enabled
          }]

          scope.saving = true;

          $http.patch(url, patch).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'))
            $timeout(function() {
              scope.saving = false;
            }, 2500)
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'))
            $timeout(function() {
              scope.saving = false;
            }, 2500)
          });
        }

        scope.changeRetentionPeriod = function (jobDefinition) {
          if (scope.retentionPeriod.keepData) {
            scope.jobDefinition.EXTERNAL.retentionPeriod = '..';
          } else {
            scope.jobDefinition.EXTERNAL.retentionPeriod = 'PT2160H';
          }

          jobDefinition.EXTERNAL.saveChanges(scope.jobDefinition.EXTERNAL).then(function () {
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function (err) {
            toastr.error($filter("translate")("ERROR"));
          })
        }

        scope.testDataExtractJobDefinition = function (jobDefinition) {
          scope[jobDefinition.targetType + '_testInProgress'] = true;
          jobDefinition.test(jobDefinition).then(function (repsonse) {
            toastr.success($filter("translate")("TestSuccessfull"));
            scope[jobDefinition.targetType + '_testInProgress'] = false;
          }).catch(function(err) {
            scope[jobDefinition.targetType + '_testInProgress'] = false;
          })
        }

        scope.createDataExtractJobDefinition = function (jobDefinition) {
          jobDefinition.create(jobDefinition).then(function () {
            angular.element('#createDB_' + jobDefinition.targetType).hide();
            getTenantsDataExtractConfig();
            toastr.success($filter("translate")("DatabaseCreated"));
          }).catch(function (err) {
            toastr.error($filter("translate")("ERROR"));
          })
        }

        scope.deleteDataExtractJobDefinition = function (jobDefinition) {
          jobDefinition.delete(jobDefinition).then(function () {
            angular.element('.dbBtns_' + jobDefinition.targetType).hide();
            getTenantsDataExtractConfig();
            toastr.success($filter("translate")("Deleted"));
          }).catch(function (err) {
            toastr.error($filter("translate")("ERROR"));
          })
        }

        scope.activateDataExtractJobDefinition = function (jobDefinition) {
          scope[jobDefinition.targetType + '_testInProgress'] = true;
          jobDefinition.test(jobDefinition).then(function () {
            scope[jobDefinition.targetType + '_testInProgress'] = false;
            jobDefinition.enabled = true;
            angular.element('#activateDB_' + jobDefinition.targetType).hide();
            jobDefinition.saveChanges(jobDefinition).then(function () {
              toastr.success($filter("translate")("Activated"));
            }).catch(function (err) {
              angular.element('#activateDB_' + jobDefinition.targetType).show();
              toastr.error($filter("translate")("ERROR"));
            })
          }).catch(function(err) {
            jobDefinition.enabled = false;
            scope[jobDefinition.targetType + '_testInProgress'] = false;
          })
        }

        scope.deActivateDataExtractJobDefinition = function (jobDefinition) {
          jobDefinition.enabled = false;
          angular.element('#deActivateDB_' + jobDefinition.targetType).hide();
          jobDefinition.saveChanges(jobDefinition).then(function () {
            toastr.success($filter("translate")("Deactivated"));
          }).catch(function (err) {
            angular.element('#deActivateDB_' + jobDefinition.targetType).show();
            toastr.error($filter("translate")("Deactivated"));
          });
        }

        scope.generateNewPasswordDataExtractJobDefinition = function (jobDefinition) {
          if (!scope.PRINTIX_testInProgress && !jobDefinition.extractInProgress) {
            jobDefinition.generateNewPassword(jobDefinition).then(function (newPassword) {
              toastr.success($filter("translate")("NewPasswordGenerated"));
              jobDefinition.sqlServerConnectData.password = newPassword;
            }).catch(function (err) {
              toastr.error($filter("translate")("ERROR"));
            })
          }
        }

        scope.copyToClipboard = function (string) {
          var input = document.createElement('input');
          input.setAttribute('value', string);
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
          toastr.success($filter("translate")("CopyToClipboard"));
        }

        scope.showDeleteWarning = function (event, context) {
          event.stopPropagation();
          scope.clearPopups();

          scope[context + '_confirmConfigurations'] = {
            confirm: 'Yes',
            warning: null,
            danger: true,
            cancel: 'No',
            validationString: null
          };

          scope[context + '_confirmPopupObject'] = {
            dimensions: { height: 85, width: 250 },
            offset: { top: 36, left: 60 },
            pointerDirection: null,
            pointerPosition: 'right',
            relativePosition: 'over',
            absoluteX: event.clientX,
            absoluteY: event.clientY,
            type: 'CONFIRM',
            title: 'Delete',
            confirmText: null,
            clickOutsideToClose: true
          }
        }

        scope.clearPopups = function () {
          scope.changeCloudstorageKeyPopupObject = null;
          scope.changeCloudstorageKeyConfiguration = null;

          scope.changeCloudstorageNamePopupObject = null;
          scope.changeCloudstorageNameConfiguration = null;

          scope.PRINTIX_confirmPopupObject = null;
          scope.PRINTIX_confirmConfigurations = null;

          scope.EXTERNAL_confirmPopupObject = null;
          scope.EXTERNAL_confirmConfigurations = null;


        }

        scope.toggleEditMode = function () {
          scope.externalDbEditMode = !scope.externalDbEditMode;
          if (!scope.externalDbEditMode && !scope.externalDbisPristine) {
            scope.jobDefinition.EXTERNAL = angular.copy(DataExtractService.jobDefinition.EXTERNAL);
          }
        }

        function formListener() {
          scope.$watch(function () {
            return scope.jobDefinition.EXTERNAL.sqlServerConnectData;
          }, function () {
            var modifiedSqlServerConnectData = scope.jobDefinition.EXTERNAL.sqlServerConnectData;
            var originalSqlServerConnectData = DataExtractService.jobDefinition.EXTERNAL.sqlServerConnectData;
            if (angular.equals(modifiedSqlServerConnectData, originalSqlServerConnectData)) {
              scope.externalDbisPristine = true;
            } else {
              scope.externalDbisPristine = false;
            }
          }, true);
        }

        scope.updateExternalDB = function (jobDefinition) {
          scope[jobDefinition.targetType + '_testInProgress'] = true;
          jobDefinition.test(jobDefinition).then(function () {
            scope[jobDefinition.targetType + '_testInProgress'] = false;
            jobDefinition.saveChanges(scope.jobDefinition.EXTERNAL).then(function () {
              scope.externalDbEditMode = false;
              toastr.success($filter("translate")("ChangesSaved"));
            }).catch(function (err) {
              angular.element('#activateDB_' + jobDefinition.targetType).show();
              toastr.error($filter("translate")("ERROR"));
            })
          }).catch(function(err) {
            scope.externalDbEditMode = false;
            scope[jobDefinition.targetType + '_testInProgress'] = false;
            scope.jobDefinition.EXTERNAL = angular.copy(DataExtractService.jobDefinition.EXTERNAL);
          })
        }

        function listeners () {
          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.EXTRACT_STARTED, function (name, data) {
            getTenantsDataExtractConfig();
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.EXTRACT_COMPLETED, function (name, data) {
            getTenantsDataExtractConfig();
          });
        }

      }
    };
  }

  pxAnalytics.$inject = [
    'DataExtractService', 'toastr', '$filter', '$http', '$timeout', 'EventServiceEvents'];

  angular
    .module('printix-admin')
    .directive('pxAnalytics', pxAnalytics);

})();
